<template lang="pug">
    div(style="with:100%; height:37px; border:0px solid;")
        div(style="float:left; width:60px; height:37px; border:0px solid red;")
            div(class="ticker blue1 pl-2 pr-2 mt-2" style="padding-top:2px;") {{ stockData.ticker }}
        div(class="text-center pt-1" style="float:left; width:calc(100% - 90px); height:37px; border:0px solid;")
            v-btn(@click="toggleEvent(false,'journal'), focusNewNoteTextField()" class="white--text" :style="highligting.journal ? 'background-color:#2CB19C;' : 'background-color:#1C8775;'" elevation="0" small) {{ $t('Journal') }}
            v-btn(@click="toggleEvent(false,'research')" class="white--text ml-8" :style="highligting.research ? 'background-color:#2CB19C;' : 'background-color:#1C8775;'" elevation="0" small) {{ $t('research') }}
            v-btn(@click="toggleEvent(false,'estimate')" class="white--text ml-8" :style="highligting.estimates ? 'background-color:#2CB19C;' : 'background-color:#1C8775;'" elevation="0" small) {{ $t('estimates') }}
        div(style="float:left; width:30px; height:37px; border:0px solid;")
            v-icon(@click="closeNavigation()" size="35" style="width:30px; border:0px solid;") mdi-close
</template>

<script>
export default {
    name: 'DrawerHeadlineButtons',
    props: {
        stockData: Object,
        highlightSelection: String
    },
    computed: {
        highligting() {
            if(this.highlightSelection === 'journal') {
                return {
                    journal: true,
                    research: false,
                    estimates: false
                };
            } else if(this.highlightSelection === 'research') {
                return {
                    journal: false,
                    research: true,
                    estimates: false
                };
            } else if(this.highlightSelection === 'estimates') {
                return {
                    journal: false,
                    research: false,
                    estimates: true
                };
            }
        }
    },
    methods: {
        toggleEvent(key, target) {
            this.$emit('childToggleEvent', { key, target });
        },
        closeNavigation() {
            this.$emit('closeNavigation');
        },
        focusNewNoteTextField() {
            setTimeout(() => {
                const element = this.$parent.$parent.$refs.myJournalElement.$refs.myTextarea.$el;

                element.focus();
            }, 300);
        }
    }
}
</script>

<style scoped>
.v-btn {
    text-transform: none !important;
}
</style>
